import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "XhsScriptViewContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "ft14 light mr12"
};
const _hoisted_3 = {
  key: 1,
  class: "ft14 light mr12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[12] || (_cache[12] = _createElementVNode("span", {
    class: "boldFont"
  }, "手动插件", -1)), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("a", {
      href: "https://www.tampermonkey.net/index.php?ext=dhdg&version=5.1.0",
      target: "_blank"
    }, "①安装插件", -1), _createElementVNode("a", {
      href: "https://airplane.zhixuein.com/xhs.scripts.js",
      class: "ml32",
      target: "_blank"
    }, "②获取脚本代码", -1)])),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "colFlex mt16"
  }, {
    default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("span", {
      class: "boldFont"
    }, "自动化盯梢机专用", -1)), _createVNode(_component_el_row, {
      class: "mt6 leftCenter"
    }, {
      default: _withCtx(() => [_cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "mr12"
      }, "① 开启盯作者", -1)), $data.watchAuthors ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(`距离下次更新还有${$data.updateAuthorInterval - $data.timerIdx % $data.updateAuthorInterval}s`), 1)) : _createCommentVNode("", true), _createVNode(_component_el_switch, {
        modelValue: $data.watchAuthors,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.watchAuthors = $event),
        onChange: _cache[1] || (_cache[1] = e => $options.printLog('盯作者:' + e))
      }, null, 8, ["modelValue"]), _cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "ml12 mr12"
      }, "② 开启笔记统计更新", -1)), $data.watchNotes ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`距离下次更新还有${$data.updateNoteInterval - $data.timerIdx % $data.updateNoteInterval}s`), 1)) : _createCommentVNode("", true), _createVNode(_component_el_switch, {
        modelValue: $data.watchNotes,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.watchNotes = $event),
        onChange: _cache[3] || (_cache[3] = e => $options.printLog('笔记统计更新:' + e))
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "pd6 colFlex box console mt16",
      ref: "console"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.logs, (log, logi) => {
        return _openBlock(), _createBlock(_component_el_row, {
          key: `log_${logi}`,
          class: "wd100"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(log), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }, 512)]),
    _: 1
  }), $data.debug ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "leftCenter mt32"
  }, {
    default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("span", null, "updateAuthorInterval:", -1)), _createVNode(_component_el_input, {
      class: "ml32",
      modelValue: $data.updateAuthorInterval,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.updateAuthorInterval = $event),
      style: {
        "width": "100px"
      }
    }, null, 8, ["modelValue"]), _cache[11] || (_cache[11] = _createElementVNode("span", {
      class: "ml32"
    }, "updateNoteInterval:", -1)), _createVNode(_component_el_input, {
      class: "ml32",
      modelValue: $data.updateNoteInterval,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.updateNoteInterval = $event),
      style: {
        "width": "100px"
      }
    }, null, 8, ["modelValue"])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}